<template>
    <div class="plug">
        <div class="plug__wrapper">
            <div class="plug__icon-wrapper">
                <icon class="plug__icon" :icon="icon" :width="width" :height="height" :color="color"></icon>
            </div>
            <div class="plug__text">{{ title }}</div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/atoms/Icon'

export default {
    name: 'Plug',
    components: {
        Icon
    },
    props: {
        title: String,
        width: Number,
        height: Number,
        color: String,
        icon: String
    }
}
</script>

<style scoped lang="scss">
.plug {
    margin: 10px;
    &__wrapper {
        background-color: #e2e2e2;
        padding: 20px;
        margin-top: 10px;
    }

    &__icon-wrapper {
        background-color: #b5b5b5;
        border-radius: 50%;
        width: 80px;
        height: 80px;
        margin: 0 auto;
        position: relative;
    }

    &__icon {
        position: absolute;
        top: 50%;
        left: 50%;
        font-weight: 700;
        transform: translate(-50%, -50%);
    }

    &__text {
        font-weight: 700;
        text-align: center;
        margin-top: 20px;
    }
}

</style>
